export default {
  // View
  outbound_title: "Outbound",
};
